"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _shared = require("../shared");

var _shared2 = _interopRequireDefault(require("./shared"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var H2 = _styledComponents["default"].h2.withConfig({
  shouldForwardProp: _shared.shouldForwardProp
}).withConfig({
  displayName: "h2__H2",
  componentId: "sc-1j22g13-0"
})(["", ";"], _shared2["default"]);

var _default = H2;
exports["default"] = _default;